import { createSlice } from '@reduxjs/toolkit';

const initialState = {}

export const loginPageSlice = createSlice({
  initialState,
  name: 'login',
  reducers: {
    initLoginPage: (state, data) => {
        state.loginData = data.payload;
    }
  }
})

export const { initLoginPage } = loginPageSlice.actions

export default loginPageSlice.reducer
